import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  allTours: [],
};

export default function tourReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_TOUR_DETAILS:
      return {
        ...state,
        allTours: [...state.allTours, ...payload],
      };
    case ActionTypes.CLEAR_TOURS:
      return {
        ...state,
        allTours: [],
      };
    default:
      return state;
  }
}
